module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-340c3ebcf274156a85a5fdd997e0f26c.png";